var map = {
	"./book.svg": 495,
	"./chat.svg": 435,
	"./legal.svg": 496,
	"./payment.svg": 497,
	"./poa.svg": 498,
	"./safe.svg": 499,
	"./scale.svg": 500,
	"./scroll.svg": 501,
	"./shield.svg": 502,
	"./will.svg": 503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213;